import { render, staticRenderFns } from "./InsuranceCompanies.vue?vue&type=template&id=70955da4&scoped=true"
import script from "./InsuranceCompanies.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanies.vue?vue&type=script&lang=js"
import style0 from "./InsuranceCompanies.vue?vue&type=style&index=0&id=70955da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70955da4",
  null
  
)

export default component.exports